import { LegalTipo } from "./tipos";

export interface SecaoLegal {
  tipo: LegalTipo;
  titulo: string;
  ancora: string;
}

/** Ids das âncoras — compartilhados com `rotasPublicas` para não divergirem. */
export const ANCORAS_LEGAIS = {
  privacidade: "politica-de-privacidade",
  termos: "termos-de-uso",
} as const;

// A ordem aqui é a ordem em que os textos aparecem na página e no índice.
export const SECOES_LEGAIS: SecaoLegal[] = [
  {
    tipo: "PRIVACY_POLICY",
    titulo: "Política de Privacidade",
    ancora: ANCORAS_LEGAIS.privacidade,
  },
  {
    tipo: "TERMS_OF_USE",
    titulo: "Termos de Uso",
    ancora: ANCORAS_LEGAIS.termos,
  },
];

export const TIPOS_LEGAIS: LegalTipo[] = SECOES_LEGAIS.map(
  (secao) => secao.tipo,
);
